import React from "react"

import { gql } from "urql"

import { faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import ordered from "src/ordered"

import { useQuery } from "hooks/urql"

import { CheckboxField } from "components/Forms/Formik/hookComponents"
import Pagination from "components/Pagination"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

const CleverUsersTable = ({
  userType,
  organizationId,
  filters,
  page,
  setPage,
}) => {
  const chooseQuery = () => {
    if (userType === "Teacher") return cleverTeachersQuery
    if (userType === "Student") return cleverStudentsQuery
  }

  const [usersResult] = useQuery({
    query: chooseQuery(),
    variables: { organizationId, page, params: filters },
  })

  return (
    <UrqlLoadingIndicator result={usersResult}>
      {({ data }) => {
        return (
          <>
            <table className="table">
              <thead>
                <tr>
                  <th>Import</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Schools</th>
                  <th>Courses</th>
                  <th>District User Identifier</th>
                  <th>Imported?</th>
                </tr>
              </thead>

              <tbody>
                {data.organization.cleverUsers.data.map(cleverUser => (
                  <tr key={cleverUser.id}>
                    <td>
                      <CheckboxField
                        isMulti
                        name={`${userType}.cleverUserIds`}
                        value={cleverUser.id}
                      />
                    </td>
                    <td>{cleverUser.fullName}</td>
                    <td>{cleverUser.email}</td>
                    <td>
                      <ul className="list-unstyled">
                        {ordered(cleverUser.cleverSchools, "name").map(
                          cleverSchool => (
                            <li key={cleverSchool.id}>{cleverSchool.name}</li>
                          )
                        )}
                      </ul>
                    </td>
                    <td>
                      <ul className="list-unstyled">
                        {ordered(cleverUser.cleverCourses, "name").map(
                          cleverCourse => (
                            <li key={cleverCourse.id}>{cleverCourse.name}</li>
                          )
                        )}
                      </ul>
                    </td>
                    <td>{cleverUser.districtUserIdentifier}</td>
                    <td>
                      {!cleverUser.user ? (
                        <FontAwesomeIcon
                          icon={faTimes}
                          className="text-danger"
                        />
                      ) : (
                        <a
                          className="btn btn-sm btn-outline-info"
                          href={cleverUser.user.showPath}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          View {userType}
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              currentPage={page}
              changePage={setPage}
              totalPages={data.organization.cleverUsers.totalPages}
            />
          </>
        )
      }}
    </UrqlLoadingIndicator>
  )
}

const cleverStudentsQuery = gql`
  query AdminOrganizationCleverUsersCleverStudents(
    $organizationId: ID!
    $page: Int!
    $params: CleverStudentSearchInputObject
  ) {
    organization(id: $organizationId) {
      cleverUsers: cleverStudents(page: $page, params: $params) {
        currentPage
        totalPages
        data {
          id
          fullName
          email
          districtUserIdentifier
          cleverSchools {
            id
            name
          }
          cleverCourses {
            id
            name
          }
          user {
            ... on Student {
              id
              firstName
              lastName
              showPath
            }
          }
        }
      }
    }
  }
`

const cleverTeachersQuery = gql`
  query AdminOrganizationCleverUsersCleverTeachers(
    $organizationId: ID!
    $page: Int!
    $params: CleverTeacherSearchInputObject
  ) {
    organization(id: $organizationId) {
      cleverUsers: cleverTeachers(page: $page, params: $params) {
        currentPage
        totalPages
        data {
          id
          fullName
          email
          districtUserIdentifier
          cleverSchools {
            id
            name
          }
          cleverCourses {
            id
            name
          }
          user {
            ... on Teacher {
              id
              firstName
              lastName
              showPath
            }
          }
        }
      }
    }
  }
`

export default CleverUsersTable
